<template>
  <div>
    <div style="margin-top: 50px;">
      <div id="feature_list_port" style="width: 100%; max-width: 1920px; display: flex; flex-direction: column; justify-content: space-between; align-items: center;">
          <div :style="'margin-top: 30px; width: 100%; display: flex; flex-direction: '+($store.getters.getScreenWidth<715 ? 'column' : 'row')+'; flex-wrap: wrap; justify-content: space-between; align-items: '+($store.getters.getScreenWidth<1024 ? 'center' : 'space-between')+';'">
              <div 
                :style="'width: '+(getFeatureBoxWidth)+'px; margin: 20px; padding-top: 20px; padding-left: 20px; padding-right: 20px; padding-bottom: 30px; display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; text-align: left; border: 1px solid #383838; border-radius: 25px;'">
                    <span style="font-size: 24px; font-weight: bold; margin-top: 20px; color: #888;">
                        Subscription Plan<br>
                        <img
                            style="width: 50px;" 
                            src="https://etacdn.b-cdn.net/new-website/android-apple-laptop.png" 
                            alt="easytailorapp">

                    </span>
                    <span :style="'margin-bottom: '+($store.getters.getVisitorGeographyDetail.country == 'IN' ? '0px' : '40px')+'; font-size: 38px; font-weight: 500; margin-top: 10px;'">
                        {{$store.getters.getVisitorGeographyDetail.country == 'IN' ? 'INR 2499' : 'USD $49.99'}}/month
                    </span>
                    <span 
                        v-if="$store.getters.getVisitorGeographyDetail.country == 'IN'" 
                        :style="'margin-bottom: 40px; font-size: 18px; font-weight: 500; margin-top: 10px;'">
                        Exclusive of GST 18%
                    </span>
                    <div
                        style="margin-bottom: 20px; display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                        <img src="https://etacdn.b-cdn.net/new-website/tick.png" style="width: 20px;"  alt="easytailorapp">
                        <span v-html="'Pay annually after trial period.'" style="margin-left: 15px; font-weight: 500; font-size: 16px;">
                            
                        </span>
                    </div>
                    <div
                        v-for="(data, index) in getFeatureList"
                        :key="index" 
                        style="margin-bottom: 20px; display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                        <img src="https://etacdn.b-cdn.net/new-website/tick.png" style="width: 20px;"  alt="easytailorapp">
                        <span v-html="data" style="margin-left: 15px; font-weight: 500; font-size: 16px;">
                            
                        </span>
                    </div>
                    <div
                        style="margin-bottom: 20px; display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                        <img src="https://etacdn.b-cdn.net/new-website/tick.png" style="width: 20px;"  alt="easytailorapp">
                        <span v-html="'**Custom Pricing For Multi-Shop Setup'" style="margin-left: 15px; font-weight: 500; font-size: 16px;">
                            
                        </span>
                    </div>
                    <div @click="$emit('toggleSignup')" style="cursor: pointer; margin-top: 30px; padding: 10px; width: 180px; border-radius: 10px; text-align: center; background-color: #000; color: white;">
                        <span :style="'font-size: '+$store.getters.getFontSizes.f13+''">
                            Get started for free.
                        </span>
                    </div>
              </div>
              <div 
                :style="'width: '+(getFeatureBoxWidth)+'px; margin: 20px; padding-top: 20px; padding-left: 20px; padding-right: 20px; padding-bottom: 30px; display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; text-align: left; border: 1px solid #383838; border-radius: 25px;'">
                    <span style="font-size: 24px; font-weight: bold; margin-top: 20px; color: #888;">
                        One-Time Payment Plan<br>
                        <img
                        style="width: 50px;" 
                        src="https://etacdn.b-cdn.net/new-website/android-apple-laptop.png" 
                        alt="easytailorapp">
                    
                    </span>
                    <span :style="'margin-bottom: '+($store.getters.getVisitorGeographyDetail.country == 'IN' ? '0px' : '40px')+'; font-size: 38px; font-weight: 500; margin-top: 10px;'">
                        {{$store.getters.getVisitorGeographyDetail.country == 'IN' ? 'INR 64999' : 'USD $2499.00'}}
                    </span>
                    <span 
                        v-if="$store.getters.getVisitorGeographyDetail.country == 'IN'" 
                        :style="'margin-bottom: 40px; font-size: 18px; font-weight: 500; margin-top: 10px;'">
                        Exclusive of GST 18%
                    </span>
                    <div
                        style="margin-bottom: 20px; display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                        <img src="https://etacdn.b-cdn.net/new-website/tick.png" style="width: 20px;"  alt="easytailorapp">
                        <span v-html="'Pay monthly after trial period.'" style="margin-left: 15px; font-weight: 500; font-size: 16px;">
                            
                        </span>
                    </div>
                    <div
                        v-for="(data, index) in getFeatureList"
                        :key="index" 
                        style="margin-bottom: 20px; display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                        <img src="https://etacdn.b-cdn.net/new-website/tick.png" style="width: 20px;"  alt="easytailorapp">
                        <span v-html="data" style="margin-left: 15px; font-weight: 500; font-size: 16px;">
                            
                        </span>
                    </div>
                    <div
                        style="margin-bottom: 20px; display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                        <img src="https://etacdn.b-cdn.net/new-website/tick.png" style="width: 20px;"  alt="easytailorapp">
                        <span v-html="'**Custom Pricing For Multi-Shop Setup'" style="margin-left: 15px; font-weight: 500; font-size: 16px;">
                            
                        </span>
                    </div>
                    <div @click="$emit('toggleSignup')" style="cursor: pointer; margin-top: 30px; padding: 10px; width: 180px; border-radius: 10px; text-align: center; background-color: #000; color: white;">
                        <span :style="'font-size: '+$store.getters.getFontSizes.f13+''">
                            Get started for free.
                        </span>
                    </div>
              </div>
              
          </div>
          <div style="margin-top: 100px; width: 100%; text-align: center; display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <img :src="'https://etacdn.b-cdn.net/new-website/add-on.png'" style="width: 50px;" alt="">
            <span :style="'font-size: 22px; font-weight: 500; margin-top: 30px;'">
                Add-Ons (Optional)
            </span>
            <span :style="'font-size: 14px; margin-top: 10px; margin-bottom: 50px;'">
                For pricing on additional services, kindly contact us.
            </span>
            <div
                v-for="(data, index) in getAddOnList"
                :key="index" 
                style="margin-bottom: 20px; display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                <img src="https://etacdn.b-cdn.net/new-website/tick.png" style="width: 20px;"  alt="easytailorapp">
                <span v-html="data" style="margin-left: 15px; font-weight: 500; font-size: 16px;">
                    
                </span>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    computed: {
        getFeatureList() {
            return [
                'Pay only for the retail outlets.', 
                'Free access to workshop units.', 
                'Free access to warehouse units.', 
                'Unlimited transactional email credits.',
                'No limit on users, unlimited users.', 
                'Free on-going support.',
                'Free e-store and customer portal.',
                'Access to all the modules.',
                'No limit on data or information.',
                'Unlimited data backups'
            ]
        },
        getAddOnList() {
            return [
                'SMS credits.',
                'WhatsApp integration.',
                'Biometrics attendance machine.',
                'Email credits for promotional emails.',
                'Shipment tracking credits'
            ]
        },
        getFeatureBoxWidth() {
            
            let width = this.$store.getters.getScreenWidth
            let returnWidth = 0

            if(width < 1030 && width >= 1094) {
                returnWidth = width/4.05
            } else if(width < 1094 && width >= 919) {
                returnWidth = width/3
            } else if(width < 919 && width >= 715) {
                returnWidth = width/2.7
            } else if(width < 715) {
                returnWidth =width/1.5
            } else {
                returnWidth =width/4.2
            }

            return Math.round(returnWidth)

        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Pricing/Row2.vue